<template>
  <div>
    <az-panel>
      <template slot="lft">
        <el-button type="primary" size="medium"
          @click="$refs['chooseCompanyTypeBar'].$emit('open')">
          <i class="azappfont az-app-create btn-lft-icon"></i>新建企业
        </el-button>
        <az-button type="refresh" size="medium" :infoNotShow="true"
          @click.native="renderList"></az-button>
      </template>
      <template slot="rt">
        <div class="block">
          状态
        </div>
        <el-select v-model="pageInfo.status" placeholder="筛选类型" size="medium"
          filterable style="width: 98px;" @change="resetPageGoPage">
          <el-option
            label="全部状态"
            :value="0">
          </el-option>
          <el-option
            v-for="item in companyStatus"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <div class="block">
          企业类型
        </div>
        <el-select v-model="pageInfo.type" placeholder="筛选类型" size="medium"
          filterable style="width: 100px;" @change="resetPageGoPage">
          <el-option label="我方公司" :value="1"></el-option>
          <el-option label="供应商" :value="2"></el-option>
          <el-option label="客户" :value="3"></el-option>
          <!-- <el-option
            v-for="item in typePermission"
            :key="item"
            :label="companyTypes.constMap.idMap[item].name"
            :value="item">
          </el-option> -->
        </el-select>
        <az-search @search="searchHandler"
          placeholder="请输入企业名称"
          :initValue="pageInfo.company_name">
        </az-search>
      </template>
    </az-panel>
    <el-table
      :data="tableList"
      ref="orderList"
      stripe
      size="small"
      style="width: 100%;">
      <el-table-column
        prop="id"
        label="企业ID">
      </el-table-column>
      <el-table-column
        prop="name"
        label="企业名称">
      </el-table-column>
      <el-table-column
        prop="type"
        label="企业类型">
        <template slot-scope="scope">
          <span>{{companyTypes.constMap.idMap[scope.row.type].name}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="企业状态">
        <template slot-scope="scope">
          <span>
            <el-tag :type="companyStatus.constMap.idMap[scope.row.status].type"
              size="mini">
              {{companyStatus.constMap.idMap[scope.row.status].name}}</el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="企业备注">
      </el-table-column>
      <el-table-column v-if="pageInfo.type != 1"
        prop="owner_company"
        label="关联公司主体">
        <template slot-scope="scope">
          <span v-if="!scope.row.owner_company">-/-</span>
          <p v-for="item in scope.row.owner_company" v-else
            :key="item">{{myCompanyMap[item] || item}}</p>
        </template>
      </el-table-column>
      <el-table-column
        align="right"
        width="160"
        label="操作">
        <template slot-scope="scope">
          <az-button size="mini" type="edit" content="编辑企业" v-if="scope.row.is_edit==1"
            @click.native="editHandler(scope.row)"></az-button>
          <az-button size="mini" type="order" v-if="isShowDetianBtn == 1"
            content="查看详情" @click.native="checkDetail(scope.row)">
          </az-button>
        </template>
      </el-table-column>
      <template slot="empty">
        <az-loading v-if="isLoading"></az-loading>
        <div v-else>暂无数据</div>
      </template>
    </el-table>
    <div class="az-pagination clearfix">
      <el-pagination
        layout="total, sizes, prev, pager, next"
        :page-sizes="[10, 20, 30, 40]"
        @size-change="resetPageGoPage"
        @current-change="goPage"
        :current-page.sync="pageInfo.page"
        :page-size.sync="pageInfo.per_page"
        :total="total"></el-pagination>
    </div>
    <company-base-form ref="companyBaseForm" @refresh="renderList"></company-base-form>
    <choose-company-type ref="chooseCompanyTypeBar"
      @choose="type => $refs['companyBaseForm'].$emit('create', type)">
    </choose-company-type>
  </div>
</template>
<script>
import azButton from '@/base/azButton.vue';
import azSearch from '@/base/azSearch.vue';
import { openConfirmModal } from '@/base/azConfirm/index.js';
import dayjs from 'dayjs';
import companyBaseForm from './companyBaseForm.vue';
import chooseCompanyType from './chooseCompanyType.vue';
import { deleteProject } from '@/api/project'
import { getCompanyList, getCompanyTypes } from '@/api/company'
import { companyTypes, companyStatus } from '@/const'

export default {
  name: 'company-list',
  components: {
    azButton,
    azSearch,
    companyBaseForm,
    chooseCompanyType
  },
  computed: {
    isShowDetianBtn() {
      return this.pageInfo.type - 0 || 1
    }
  },
  data() {
    return {
      tableList: [],
      myCompanyMap: {},
      options: [],
      checkeds: [],
      typePermission: [],
      isLoading: true,
      cancel: null,
      keyword: '',
      total: 0,
      pageInfo: {
        page: 1,
        per_page: 10,
        type: null,
        company_name: '',
        status: 0
      },
      groupList: [
        {
          id: '',
          name: '所有分组'
        }
      ],
      companyTypes,
      companyStatus
    }
  },

  methods: {
    resetPageGoPage() {
      this.pageInfo.page = 1;
      this.goPage();
    },
    getMyCompanyList() {
      if (this.company_type == 1) return;
      let query = {
        status: 0,
        page: 1,
        per_page: 2000,
        type: 1
      }
      getCompanyList(query).then(res => {
        if (res.code != 0) {
          this.$message({
            message: res.message,
            type: 'error'
          })
        }
        this.myCompanyList = res.data.items;
        console.log(this.myCompanyList, 'myCompanyList');
        // this.companyList = res.data.items.map(item => {
        //   return { name: item.name, id: item.id }
        // })
      })
    },
    handleSelectionChange(checkeds) {
      this.checkeds = checkeds;
    },

    editHandler(row) {
      this.$refs['companyBaseForm'].$emit('edit', row);
    },
    checkDetail(row) {
      row.isDisabled = true;
      this.$refs['companyBaseForm'].$emit('detail', row)
    },

    toCancel() {
      if (this.cancel) {
        this.cancel();
      }
    },

    initParams(route) {
      this.pageInfo.page = route.query.page - 0 || 1;
      this.pageInfo.type = route.query.type - 0 || 1;
      this.pageInfo.per_page = route.query.per_page - 0 || 10;
      this.pageInfo.company_name = route.query.company_name || '';
    },
    initCompanyTypesPermission() {
      getCompanyTypes().then(res => {
        if (res.code != 0) throw new Error(res.message);
        this.typePermission = res.data || [];
        this.initParams(this.$route);
        this.renderList();
      })
    },
    async renderList() {
      this.tableList = [];
      this.isLoading = true;
      this.toCancel();
      let query = {
        status: 0,
        page: 1,
        per_page: 2000,
        type: 1
      }
      try {
        let res = await getCompanyList({ ...this.pageInfo });
        if (res.code != 0) {
          this.isLoading = false;
          this.$message({ type: 'error', message: res.message })
        }
        this.tableList = res.data?.items || [];
        this.total = res.data?.total || 0;
        this.isLoading = false;
        if (this.pageInfo.type != 1) {
          let myCompanyRes = await getCompanyList(query)
          if (myCompanyRes.code != 0) return;
          let myCompanyList = myCompanyRes.data.items;
          if (myCompanyList && myCompanyList.length > 0) {
            let maps = {}
            myCompanyList.forEach(item => {
              maps[item.id] = item.name
            })
            this.myCompanyMap = maps;
          }
        }
      } catch (err) {
        console.log(err)
        this.isLoading = false;
      }
    },
    goPage() {
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.pageInfo,
          __: dayjs().valueOf()
        }
      });
    },
    handleModify(row) {
      this.$refs['orgCardDialogRef'].$emit('edit');
    },
    searchHandler(val) {
      this.pageInfo.company_name = val;
      this.resetPageGoPage();
    },
    deleteHandler(customerId) {
      const beforeClose = (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '删除中...';
          deleteProject(customerId).then(res => {
            if (res.code != 0) throw new Error(res.message);
            this.dialogVisible = false;
            this.$message.success('客户删除成功~！');
            done();
            this.renderList();
          }).catch(err => {
            this.$message.error(err.response && err.response.data ? err.response.data.message : err.message);
          }).finally(() => {
            instance.confirmButtonLoading = false;
          })
        } else {
          done();
        }
      };

      openConfirmModal(this, {
        title: '删除提示',
        txt: '您确定要删除所选客户吗？',
        type: 'danger',
        beforeClose: beforeClose
      }).then(action => {
        console.log('1')
      }).catch(err => {
        console.log(err);
      }).finally(() => {
      });
    }
  },

  beforeRouteUpdate(to, from, next) {
    this.initParams(to);
    this.renderList();
    next();
  },

  created() {
    this.initCompanyTypesPermission()
    // this.initParams(this.$route);
    // this.renderList();
  },
  mounted() {
    console.log(this.pageInfo.type, 'pageinfo.type')
  }
}
</script>